import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TypedForm, TypedFormOwnControls} from '../../../common/form-types';
import {WidgetImplSettingsComponentBase} from '../../components/widget-impl-settings-component-base';
import {DexDynWidget} from '../dex-dyn-widget';
import {DexDynWidgetSettings} from './dex-dyn-widget-settings';

interface SettingsFormValue {
    title: string;
}

@Component({
    selector:    'dex-dyn-widget-settings',
    templateUrl: './dex-dyn-widget-settings.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone:  false
})
export class DexDynWidgetSettingsComponent extends WidgetImplSettingsComponentBase<DexDynWidget> {

    @Input()
    public override widget: DexDynWidget;

    public form: TypedForm<SettingsFormValue>;

    protected override buildForm(): void {
        const settings: DexDynWidgetSettings = this.widget.implementationInstance.settings;

        const controls: TypedFormOwnControls<SettingsFormValue> = {
            title:   this.createTitleFormControl(settings)
        };

        this.form = new FormGroup(controls) as TypedForm<SettingsFormValue>;
    }

}
